export default "__VITE_ASSET__By0gb68Q__"